import React from 'react';
import { write, useSnap } from '../../store'
import toast from 'react-hot-toast';


function KoreanWelcome() {
    const read = useSnap()


    return (

        <>

            <div className="flex flex-col">

            <h1 className = 'text-3xl'>
                     어서 오십시오،
                 </h1>
                 <p>
                      이 시험에는 {read.totalQuestions}개의 문항이 포함되어 있으며 읽기 및 듣기 질문에 답하는 데 60초, 말하기 질문에 90초가 소요되며 쓰기 질문에는 변수 시간이 주어집니다.
                  </p>
                 <br />
                 <p>
                     애플리케이션의 오른쪽 상단에 관련 질문에 대한 타이머가 표시되고 왼쪽 상단에 웹캠이 기록됩니다.
                 </p>
                 <br />
                 <p>
                     귀하는 당사의 서비스 약관을 읽고 동의해야 하며 시험에 응시하려면 활성 웹캠과 마이크가 있어야 합니다.
                 </p>
                 <br />
                 <p>
                     웹캠이 작동하지 않아 자신을 볼 수 없거나 마이크가 연결된 경우 시작 버튼이 활성화되지 않아 시험을 시작할 수 없습니다. 시험에 응시하기 전에 웹캠과 마이크가 작동하는지 반드시 확인해야 합니다.
                 </p>
                 <br />
                 <p>
                     우리는 당신의 목소리와 비디오를 녹음하고 있기 때문에 당신의 인터넷 연결이 제대로 작동하는지 확인해야 합니다. 연결이 끊긴 경우 동일한 링크를 사용하여 중단한 부분부터 시험을 계속할 수 있습니다.
                 </p>
                 <br />
                 <p>
                     객관식 질문에는 마이너스 점수가 없으므로 가능한 한 모든 질문에 자유롭게 답하십시오.
                 </p>
                 <br />
                 <h1 className = 'text-2xl'>
                    지침을 이해하셨다면 "이해함"을 누르고 시험을 시작하실 수 있습니다. 행운을 빌어요!
                 </h1>

             </div>
        </>
    )



}


export default KoreanWelcome